import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://react-my-burger-highway11.firebaseio.com/'
})

export default instance;